var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPpIcon = function SvgPpIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#D8D8D8",
    cx: 18,
    cy: 18,
    r: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 10a8 8 0 1 1 0 16 8 8 0 0 1 0-16Zm.383 3.2h-.959v1.51c-.13.03-.263.07-.396.118-1.618.589-1.618 2.84.022 3.35l.117.035.566.166.418.128c.768.249 1.061.453 1.152.787.14.52-.33 1.024-1.043 1.09-.65.061-1.284-.192-1.989-.715l-.571.77.202.145c.507.35 1.007.591 1.522.701v1.506h.96v-1.455c1.23-.132 2.158-1.135 1.844-2.293-.225-.833-.81-1.17-2.166-1.567l-.728-.214c-.747-.233-.747-1.253.022-1.533.612-.223 1.198-.154 1.827.115l.232.106.196.098.422-.862-.337-.164-.136-.06a3.903 3.903 0 0 0-1.176-.314V13.2Z",
    fill: "#000"
  }))));
};
export default SvgPpIcon;